import { z } from 'zod';

// groups / wallets / devices — server sends count+limit, no is_limit_reached flag
const UsageCounterDtoSchema = z
  .object({
    count: z.number().nullish(),
    limit: z.number().nullish(),
    is_limit_reached: z.boolean().nullish(), // optional — computed in mapper when absent
    days_until_reset: z.number().nullish(),
  })
  .nullish();

// attachments — server sends week_used+weekly_limit, no is_weekly_limit_reached flag
const AttachmentUsageDtoSchema = z
  .object({
    week_used: z.number().nullish(),
    weekly_limit: z.number().nullish(),
    is_weekly_limit_reached: z.boolean().nullish(), // optional — computed in mapper when absent
    days_until_reset: z.number().nullish(),
    max_file_size_mb: z.number().nullish(),
  })
  .nullish();

// exports — server sends month_used+monthly_limit, no is_monthly_limit_reached flag
const ExportUsageDtoSchema = z
  .object({
    month_used: z.number().nullish(),
    monthly_limit: z.number().nullish(),
    is_monthly_limit_reached: z.boolean().nullish(), // optional — computed in mapper when absent
    days_until_reset: z.number().nullish(),
  })
  .nullish();

// receipt_scans — server sends remaining + optional is_limit_reached
const ScanUsageDtoSchema = z
  .object({
    remaining: z.number().nullish(),
    week_used: z.number().nullish(),
    weekly_limit: z.number().nullish(),
    days_until_reset: z.number().nullish(),
    is_limit_reached: z.boolean().nullish(), // optional — computed from remaining when absent
    is_first_week: z.boolean().nullish(),
  })
  .nullish();

// reminders — actual server shape: { remind_all, personal, combined }
const ReminderPeriodDtoSchema = z
  .object({
    week_used: z.number().nullish(),
    weekly_limit: z.number().nullish(),
    remaining: z.number().nullish(),
    days_until_reset: z.number().nullish(),
    is_limit_reached: z.boolean().nullish(),
  })
  .nullish();

const RemindersDtoSchema = z
  .object({
    remind_all: ReminderPeriodDtoSchema,
    personal: ReminderPeriodDtoSchema,
    combined: ReminderPeriodDtoSchema,
  })
  .nullish();

const PlanUsageDtoSchema = z.object({
  is_pro: z.boolean().nullish(),
  groups: UsageCounterDtoSchema,
  wallets: UsageCounterDtoSchema,
  receipt_scans: ScanUsageDtoSchema,
  attachments: AttachmentUsageDtoSchema,
  exports: ExportUsageDtoSchema,
  devices: UsageCounterDtoSchema,
  reminders: RemindersDtoSchema,
  pro_user_ids: z.array(z.string()).nullish(),
});

export const PlanUsageResponseSchema = z.object({
  status: z.boolean().optional(),
  data: PlanUsageDtoSchema.nullish(),
});

export type PlanUsageDto = z.infer<typeof PlanUsageDtoSchema>;
export type PlanUsageResponse = z.infer<typeof PlanUsageResponseSchema>;
